import moment from 'moment';

/**
 * Formatea una fecha a 'DD/MM/YYYY' o 'DD/MM/YYYY hh:mm A' si showTime es true.
 * @param {Date|string} value - Fecha a formatear.
 * @param {boolean} showTime - Si es true, incluye la hora.
 * @returns {string} Fecha formateada o cadena vacía si no hay valor.
 */
export const formatDate = (value, showTime = false) => {
  if (value) {
    return showTime
      ? moment(value).local().format('DD/MM/YYYY hh:mm A')
      : moment(value).local().format('DD/MM/YYYY');
  }
  return '';
};

/**
 * Formatea una fecha a 'YYYY-MM-DD' en hora local.
 * Si no se proporciona valor, retorna una cadena vacía.
 * @param {Date|string} [fecha] - Fecha opcional a formatear.
 * @returns {string} Fecha formateada en formato 'YYYY-MM-DD'.
 */
export const formatearFechaLocal = (fecha = null) => {
  return fecha ? moment(fecha).local().format('YYYY-MM-DD') : '';
};
